<ng-select
  [clearable]="true"
  [searchFn]="customSearchFn"
  class="dropdown-credit truncate-option"
  placeholder="Selecione o Contrato"
  (change)="selectContract($event)"
  [hideSelected]="true"
  notFoundText="Não encontrado">
  @for (contract of conditions(); track contract.contractId) {
    <ng-option [value]="contract">
      <span class="truncate-text">
          {{ contract.contractId }}
        @if (contract.contractName) {
          ({{ contract.contractName }})
        }
      </span>
    </ng-option>
  }
</ng-select>
